// Seletor da janela de referência (SDD §3.4) — persiste como preferência do usuário
import { getPrefs, setPrefs } from '../auth';
import { JanelaRef, Periodo } from '../types';

interface Props {
  value: JanelaRef;
  custom?: Periodo;
  onChange: (ref: JanelaRef, custom?: Periodo) => void;
}

export default function JanelaRefSelect({ value, custom, onChange }: Props) {
  const aplicar = (janela_ref: JanelaRef, c: Periodo | undefined = custom) => {
    setPrefs({ ...getPrefs(), janela_ref, custom_de: c?.de, custom_ate: c?.ate });
    onChange(janela_ref, c);
  };
  return (
    <>
      <label>Referência</label>
      <select value={value} onChange={(e) => aplicar(e.target.value as JanelaRef)}>
        <option value="YTD">YTD</option>
        <option value="12M">12 meses móveis</option>
        <option value="ANO_ANT">Ano anterior</option>
        <option value="CUSTOM">Personalizado</option>
      </select>
      {value === 'CUSTOM' && (
        <>
          <input type="date" value={custom?.de || ''} onChange={(e) => aplicar('CUSTOM', { ...custom, de: e.target.value })} />
          <input type="date" value={custom?.ate || ''} onChange={(e) => aplicar('CUSTOM', { ...custom, ate: e.target.value })} />
        </>
      )}
    </>
  );
}
